import React from "react";
import { withTranslation } from "react-multi-lang";
import $, { isArray } from "jquery";
import { Modal, ModalBody } from "reactstrap";


import {
  Grid,
  GridColumn as Column,
  GridColumnMenuSort,
  GridColumnMenuFilter,
  GridToolbar,
  GridColumnMenuWrapper
} from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { GridPDFExport } from '@progress/kendo-react-pdf';
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { gzip } from "pako";
import { saveAs } from 'file-saver';
import {
  ColumnMenuCheckboxFilter,
  CustomCell,
  CustomHeader,
  // CustomButtonCell,
  CustomButtonHeader,
  CustomButtonHeaderforusergroup,
  ColumnMenu,
  CustomOrderTransaction,
  OrderharedbymeAlart,
  CompletedCelltemp,
  ProtocolorderunshareViewCell1,
  Protocolactioncell,
  Sheetactioncell,
  Protocolactionsharbycell,
  Sheetactionsharebycell,
  MyCustomButtonCell,
  Parseractioncell,
  InventoryCell,
  MaterialCell,
  MaterialNameAction,
  EquipmentCell,
  LogbookNameAction,
  CustomHeaderUserRights,
} from "./columnMenu.jsx";
import PendingprotocolorderViewCell from "./PendingprotocolorderViewCell.jsx";
import PendingViewCell from "./PendingViewCell.jsx";
import CustomDetailviewCell, { Customcompletecell, FormatResultUsedDetailscell, FormatResultUsedEquipment, FormateTransactionHistoryDetails, Formatprotocolordertransactioncell, Formatprotocolversiondetailscell, } from "./CustomDetailviewCell.jsx";
import { CustomUsergroupviewCells, Custominventrycells, Formatprotocolversioncell, Formatprotocoltransactioncell } from "./CustomDetailviewCell.jsx";
import { LocalizationProvider, loadMessages } from "@progress/kendo-react-intl";
import { ShareforsheetTemplate, Shareorder, UnshareforprotocolTemplate, } from "./../custom_functions/ManipulationFunction.jsx";
import enMessages from './../custom_modules/translations/en/en.json';
import koMessages from './../custom_modules/translations/ko/ko.json';
import frMessages from './../custom_modules/translations/fr/fr.json';
import grMessages from './../custom_modules/translations/de/de.json';
import { withAlert } from "react-alert";
import { Servicecalls, sortDataByDate, ExcelExport as excelexportcustomize } from "./../custom_functions/Functions.jsx";
import { NavLink } from "react-router-dom";
import ImportData from "./ImportData.jsx";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { isMultitenant } from "../custom_functions/Constance.jsx";
import { CheckBox } from "../custom_modules/methodsetup/components/CustomControls.jsx";
// import { SplitButton } from "@progress/kendo-react-buttons";
import { Button } from "react-bootstrap";
import { getter } from "@progress/kendo-react-common";


// const Userdetail = React.lazy(() => import("./../custom_modules/general/Userdetail.jsx"));

loadMessages(enMessages, "en-En");
loadMessages(koMessages, "ko-KO");
loadMessages(frMessages, "fr-FR");
loadMessages(grMessages, "de-DE");
const axios = require("axios");

const initialPagerType = "numeric";
let itemperpage =
  localStorage.getItem("Elnitemperpage") !== undefined &&
    localStorage.getItem("Elnitemperpage") !== null
    ? parseInt(localStorage.getItem("Elnitemperpage"))
    : 10;

class KendoGridView extends React.Component {
  lastSelectedIndex = 0;
  Ismultiselect = false;
  constructor(props) {
    super(props);

    let dataset = {};
    dataset.source = this.props.source !== undefined ? this.props.source : [];

    this.state = {
      ...this.createDataState(0, 10, dataset, []),  // Assuming dataset is defined somewhere
      isPopupVisible: false
    };
    this.state.showhidecolumns = this.props.Columns;
    this.state.loadGrid = false;
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    this.rendercolumn = [];
    this.renderfield = [];
    this.onsavefinaldata = [];
    this.enableTooltip = props?.enableTooltip
    this.gridUniqueId = props?.name
    this.export = React.createRef(null);
    this.isDuplicateobj = {
      "isDuplicate": false,
      "index": -1,
      "emptycolumnname": "",
      "totalcolumnempty": 0
    };
    // this.pdfExport = React.createRef(null);
    this.ELNurl = window.appUrl.ELN;
    this.idGetter = getter(this.props.primaryKey);
    this.month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];
  }

  componentDidUpdate(prevProps) {
    if (prevProps.primaryKey !== this.props.primaryKey) {
      this.idGetter = getter(this.props.primaryKey);
    }
    const groupingPanel = document.querySelector(".k-grouping-drop-container");
    if (groupingPanel) {
      const currentText = groupingPanel.textContent || "";
      const cleanedText = currentText.replace(/\uFFFD/g, "");
      if (currentText !== cleanedText) {
        groupingPanel.textContent = cleanedText;
      }
    }
  }


  componentDidMount() {
    this.updateWindowDimensions();

    const groupingPanel = document.querySelector(".k-grouping-drop-container");
    if (groupingPanel) {
      groupingPanel.innerHTML = groupingPanel.innerHTML.replace(/\uFFFD/g, "");
    }

    window.addEventListener("resize", this.updateWindowDimensions);

    // itemperpage = localStorage.getItem("Elnitemperpage") !== undefined && localStorage.getItem("Elnitemperpage") !== null ? parseInt(localStorage.getItem("Elnitemperpage")) : 10;
    itemperpage = (this.props.Gridname !== undefined && ((this.props.Gridname === "orders") || (this.props.Gridname === "template"))) ?
      localStorage.getItem("ElnitemperpageDashboard") !== undefined && localStorage.getItem("ElnitemperpageDashboard") !== null ? parseInt(localStorage.getItem("ElnitemperpageDashboard")) : 10
      : localStorage.getItem("Elnitemperpage") !== undefined && localStorage.getItem("Elnitemperpage") !== null ? parseInt(localStorage.getItem("Elnitemperpage")) : 10;
    if (this.props.name !== undefined) {

      let passObjDet = {
        gridname: this.props.name,
        usercode: $.session.get("User"),
        sitecode: $.session.get("Usersite"),
      };

      Servicecalls("" + this.ELNurl + "/User/getGroupedcolumn", passObjDet, this.ongetgroupsuccess.bind(this), this.ongetgroupfailure.bind(this));
    }

    if (this.props.showhidesgridname !== undefined) {
      let passObjDet = {
        gridname: this.props.showhidesgridname,
        usercode: sessionStorage.User,
        sitecode: sessionStorage.Usersite,
      };

      Servicecalls("" + this.ELNurl + "/User/getShowHideolumn", passObjDet, this.onGetShowHideColsuccess.bind(this), this.ongetgroupfailure.bind(this));
    } else {
      this.setState({ showhidecolumns: this.props.Columns, loadGrid: true })
    }

    // let lang = localStorage.getItem("ElnLang") === "ko" ? 'ko' : localStorage.getItem("ElnLang") === "fr" ? 'fr' : undefined;

    // const descriptionElement = document.querySelector('.k-indicator-container');
    // const noRecordsElement = document.querySelector('.k-grid-norecords td');

    // if (descriptionElement) {
    //   let content = "Drag a column header and drop it here to group by that column";
    //   if(!lang){
    //     content = 'Drag a column header and drop it here to group by that column';
    //   }else if(lang?.trim() === 'ko'){
    //     content = '열 머리글을 끌어서 여기에 놓아 해당 열별로 그룹화하세요.';
    //   }else if(lang?.trim() === 'fr'){
    //     content = 'Faites glisser un en-tête de colonne et déposez-le ici pour regrouper par cette colonne';
    //   }
    //   descriptionElement.textContent = content;
    // }

    // if (noRecordsElement) {
    //   let content = "No records available";
    //   if(!lang){
    //     content = 'No records available';
    //   }else if(lang?.trim() === 'ko'){
    //     content = '사용 가능한 기록이 없습니다.';
    //   }else if(lang?.trim() === 'fr'){
    //     content = 'Aucun enregistrement disponible';
    //   }
    //   noRecordsElement.textContent = content;
    // }
    setTimeout(() => {
      this.Initiatedata(this.props);
    }, 100);

  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
    this.Initiatedata(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.Initiatedata(nextProps);
    if (nextProps.importlistpopup !== undefined && nextProps.importlistpopup) {
      this.setState({ IsOpen: false })
    }
    // if (nextProps?.gridRefresh === true && JSON.stringify(nextProps.Columns) !== JSON.stringify(this.state.showhidecolumns)) {
    if (nextProps?.gridRefresh === true) {
      this.setState({ showhidecolumns: nextProps.Columns, loadGrid: true })
      if (nextProps?.gridRefreshUpdateevent !== undefined) {
        nextProps.gridRefreshUpdateevent();
      }
    }
  }

  // exportPDF = () => {
  //   if (gridPDFExport !== null) {
  //     gridPDFExport.save();
  //   }
  // };

  togglePopup = () => {
    this.setState((prevState) => ({
      isPopupVisible: !prevState.isPopupVisible,
    }));
  };

  async onxportcsv() {
    const { showhidecolumns } = this.state;
    const visibleColumns = showhidecolumns
      .filter(col => col.visible && col?.datatype !== "select")
      .map(col => ({
        header: col.header,
        field: col.datatype,
      }));

    if (visibleColumns.length === 0) {
      alert('No columns are selected for export!');
      return;
    }
    const data = this.state.orginaldata;

    if (!Array.isArray(data) || data.length === 0) {
      alert('No data available for export!');
      return;
    }
    const csvHeader = visibleColumns.map(col => col.header).join(",");
    const csvBody = data.map((row, index) => {
      let jsonData = {};
      if (Array.isArray(row)) {
        const jsonStr = row[row.length - 1];
        try {
          jsonData = typeof jsonStr === "string" ? JSON.parse(jsonStr) : {};
        } catch (e) {
          console.warn(`Row ${index} has invalid JSON:`, jsonStr);
          return "";
        }
      } else {

        jsonData = row;
      }
      //...
      if (this.props.screenName !== undefined && this.props.screenName === "UserMaster") {
        if (Array.isArray(jsonData.multiusergroupcode)) {
          const usergroupNames = jsonData.multiusergroupcode
            .map(group => group?.lsusergroup?.usergroupname)
            .filter(Boolean);
          jsonData.userrole = usergroupNames.join(", ");
        } else {
          jsonData.userrole = "";
        }

        if (Array.isArray(jsonData.lsmultisites)) {
          const siteNames = jsonData.lsmultisites
            .map(siteObj => siteObj?.lssiteMaster?.sitename)
            .filter(Boolean);
          jsonData.sitename = siteNames.join(", ");
        } else {
          jsonData.sitename = "";
        }
      }
      return visibleColumns.map(col => {
        let val = jsonData[col.field];
        if (val === undefined || val === null) val = "";
        if (typeof val === "string" && (val.includes(",") || val.includes('"'))) {
          val = `"${val.replace(/"/g, '""')}"`;
        }

        return val;
      }).join(",");
    }).filter(Boolean);

    const csvContent = [csvHeader, ...csvBody].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${this.props.screenName || "Export"}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  excelExport = (values) => {
    // if (this.export.current !== null && this.props.custom_Export === undefined) {
    //   this.export.current.save();
    // } else if (this.props.custom_Export && this.props.onExportClick !== undefined) {
    //   this.props.onExportClick();
    // }....old code
    if (this.export.current !== null && this.props.custom_Export === undefined) {
      let expoval = this.export.current;
      if (this.props.screenName !== undefined && this.props.screenName === "UserMaster") {
        console.log("export");
        expoval.props.data?.forEach((item) => {
          if (Array.isArray(item.multiusergroupcode)) {
            const usergroupNames = item.multiusergroupcode.map(group => group?.lsusergroup?.usergroupname).filter(Boolean) || "";
            item.userrole = usergroupNames.join(",");
          }
          else {
            item.userrole = "";
          }
          const siteNames = Array.isArray(item?.lsmultisites) ? item.lsmultisites.map(obj => obj?.lssiteMaster?.sitename).filter(Boolean) : [];

          item.sitename = siteNames.join(", ");

        });
      }
      if (this.state.showhidecolumns.filter((col) => col.datatype === "select").length > 0) {
        excelexportcustomize({ data: expoval.props.data, headers: this.state.showhidecolumns.filter((col) => col.datatype !== "select"), fileName: this.props.screenName + "_export" });
      }
      else {
        this.export.current.save();
      }
    } else if (this.props.custom_Export && this.props.onExportClick !== undefined) {
      this.props.onExportClick();
    }
  };

  ongetgroupsuccess(response) {
    if (response !== null && response !== undefined) {
      let dataset = this.state.dataState;
      dataset.group = JSON.parse(response.gridcolumns);
      this.setState(
        this.createDataState(
          this.state.skip,
          this.state.pageSize,
          dataset,
          this.state.collapsedIds
        )
      );

      this.setState({ gridgroupcode: response.usergroupedcolcode });
    }
  }

  ongetgroupfailure(response) { }

  Initiatedata(nextProps) {
    let newdata = nextProps.source;

    if (newdata !== undefined && newdata !== null && newdata.length > 0) {
      if (
        nextProps.SelectedRecordsArray !== undefined &&
        nextProps.SelectedRecordsArray !== null &&
        nextProps.SelectedRecordsArray.length > 0
      ) {
        newdata.map((obj) => {
          if (
            nextProps.SelectedRecordsArray.findIndex(
              (objsel) =>
                objsel[nextProps.primaryKey] === obj[nextProps.primaryKey]
            ) > -1
          ) {
            obj.select = true;
          } else {
            obj.select = false;
          }
          return obj;
        });
      }
    }

    this.setState({ orginaldata: newdata !== undefined ? newdata : [] });

    if (
      this.state.orginaldata !== undefined &&
      this.state.orginaldata.length <= 0
    ) {
      let skip = this.state.dataState.skip;
      if (skip === undefined) {
        skip = 0;
      }
      if (
        this.state.dataState.skip >= itemperpage &&
        newdata.length < itemperpage
      ) {
        skip = 0;
      }
      let dataset = this.state.dataState;
      dataset.source = newdata !== undefined ? newdata : [];
      this.setState(
        this.createDataState(
          skip,
          itemperpage,
          dataset,
          this.state.collapsedIds
        )
      );
    } else if (
      newdata !== undefined &&
      this.state.dataState?.skip >= newdata.length
    ) {
      let dataset = this.state.dataState;
      dataset.source = newdata;
      this.setState(
        this.createDataState(
          0,
          itemperpage,
          dataset,
          this.state.collapsedIds
        )
      );
    } else {
      let dataset = this.state.dataState;
      dataset.source = newdata !== undefined ? newdata : [];
      this.setState(
        this.createDataState(
          this.state.skip,
          itemperpage,
          dataset,
          this.state.collapsedIds
        )
      );
    }
  }

  createDataState = (skip, take, dataState, collapsedIds) => {
    this.renderfield = [];
    let data = dataState.source;
    // let itemperpage = localStorage.getItem("Elnitemperpage") !== undefined &&
    //   localStorage.getItem("Elnitemperpage") !== null
    //   ? parseInt(localStorage.getItem("Elnitemperpage"))
    //   : 10;
    let itemperpage = (this.props.Gridname !== undefined && ((this.props.Gridname === "orders") || (this.props.Gridname === "template"))) ?
      localStorage.getItem("ElnitemperpageDashboard") !== undefined && localStorage.getItem("ElnitemperpageDashboard") !== null ? parseInt(localStorage.getItem("ElnitemperpageDashboard")) : 10
      : localStorage.getItem("Elnitemperpage") !== undefined && localStorage.getItem("Elnitemperpage") !== null ? parseInt(localStorage.getItem("Elnitemperpage")) : 10;
    // dataState.take = this.props.pageSizeable ? this.props.pageperrecors : itemperpage;
    dataState.take = itemperpage;
    dataState.skip = skip;
    let griddata = process(data, dataState);
    const validDateFields = ["createdateview", "createdateprotocol", "createondate", "createdonview", "createddateview", "transactiondate", "sDate", "dcreateddate", "addedonview"];
    if (dataState.sort && dataState.sort[0] && validDateFields.includes(dataState.sort[0].field)) {
      const sortedGridData = sortDataByDate(this.state.orginaldata, dataState.sort[0].dir);
      dataState.sort[0].field = "createdate";
      dataState.source = sortedGridData;
      griddata = process(sortedGridData, dataState);
    }
    return {
      //data: process(data.slice(skip, take + skip), dataState),
      data: griddata,
      dataState: dataState,
      total: this.props.total !== undefined ? this.props.total : griddata.total,
      skip: skip,
      group: dataState.group,
      pageSize: itemperpage,
      collapsedIds: collapsedIds,
      //pageable: this.props.pageSizeable ? { pageSize: 1, buttonCount: 5, info: true, pageSizeable: false } :
      pageable: {
        buttonCount: 5,
        info: true,
        type: initialPagerType,
        pageSizes: (this.props.Gridname !== undefined &&
          ((this.props.Gridname === "orders") || (this.props.Gridname === "template")))
          ? [5, 10, 20, 30]
          : [5, 10, 20, 30, 40, 60, 80, 100],

        previousNext: true,
      },
    };
  };

  dataStateChange = (event) => {

    let dataset = event.dataState;

    if (event.nativeEvent !== undefined && event.nativeEvent.type === "reset") {
      dataset.sort = undefined
    }
    //let filtes =
    dataset.source = this.state.orginaldata;
    this.setState(
      this.createDataState(
        this.state.skip,
        this.state.pageSize,
        dataset,
        this.state.collapsedIds
      )
    );
  };

  onGroupChange = (event) => {

    // let dataset = this.state.dataState;
    // dataset.group = event.group;
    // this.setState(
    //   this.createDataState(
    //     this.state.skip,
    //     this.state.pageSize,
    //     dataset,
    //     this.state.collapsedIds
    //   )
    // );
    const dataset = JSON.parse(JSON.stringify(this.state.dataState));
    dataset.group = event.group;
    setTimeout(() => {
      this.setState(
        this.createDataState(
          this.state.skip,
          this.state.pageSize,
          dataset,
          this.state.collapsedIds
        )
      );
    }, 100);
    if (this.props.name !== undefined) {
      let passObjDet = {};
      if (this.state.gridgroupcode !== undefined) {
        passObjDet = {
          usergroupedcolcode: this.state.gridgroupcode,
          gridname: this.props.name,
          gridcolumns: JSON.stringify(event.group),
          usercode: $.session.get("User"),
          sitecode: $.session.get("Usersite"),
        };
      } else {
        passObjDet = {
          gridname: this.props.name,
          gridcolumns: JSON.stringify(event.group),
          usercode: $.session.get("User"),
          sitecode: $.session.get("Usersite"),
        };
      }

      Servicecalls("" + this.ELNurl + "/User/setGroupedcolumn", passObjDet, this.onSetgroupsuccess.bind(this), this.onSetgroupfailure.bind(this));
    }
  };

  onSetgroupsuccess(response) {
    if (response !== null && response !== undefined) {
      this.setState({ gridgroupcode: response.usergroupedcolcode });
    }
  }

  onSetgroupfailure(response) { }

  onExpandChange = (event) => {

    const item = event.dataItem;
    const isExpanded =
      event.dataItem.expanded === undefined
        ? event.dataItem.aggregates
        : event.dataItem.expanded;
    event.dataItem.expanded = !isExpanded;
    this.setState(this.state.data)
    if (item.groupId) {
      const collapsedIds = !event.value
        ? [...this.state.collapsedState, item.groupId]
        : this.state.collapsedState.filter(
          (groupId) => groupId !== item.groupId
        );

      this.setState(
        this.createDataState(
          this.state.skip,
          this.state.pageSize,
          this.state.dataState,
          collapsedIds
        )
      );
    }
  };

  selectionChange = (event) => {
    const data = this.state.orginaldata.map((item) => {
      if (event.dataItem !== undefined && event.dataItem !== null &&
        item[this.props.primaryKey] === event.dataItem[this.props.primaryKey]
      ) {
        item.select = !event.dataItem.select;
        if (item.select === 1) {
          item.select = true;
        }
      }

      return item;
    });

    this.formatdata(data, event);
  };

  rowClick = (event) => {
    let last = this.lastSelectedIndex;
    if (this.state.orginaldata === undefined) return;

    const data = [...this.state.orginaldata];
    const current = data.findIndex((dataItem) => dataItem === event.dataItem);

    if (!this.Ismultiselect) {
      this.lastSelectedIndex = last = current;
      data.forEach((item) => (item.select = false));
      let select = !event.dataItem.select;
      for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
        data[i].select = select;
      }
    } else {
      if (!event.nativeEvent.shiftKey) {
        this.lastSelectedIndex = last = current;
      }

      if (!event.nativeEvent.ctrlKey) {
        //  data.forEach(item => (item.select = false));
      }

      let select = !event.dataItem.select;
      for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
        data[i].select = select;
      }
    }
    // const selectedData = data.find((item) => item.select === true || item.select === 1);
    // const formatDataArgs = {
    //   select: { [selectedData[this.props.primaryKey]]: true }
    // };
    this.formatdata(data);
  };

  formatdata(data) {
    this.setState({ orginaldata: data });
    let dataset = this.state.dataState;
    dataset.source = data;
    this.setState(this.createDataState(this.state.skip, this.state.pageSize, dataset, this.state.collapsedIds));
    this.fetchselectrecords(data);
  }

  fetchselectrecords(dataval) {
    console.log("selected record")
    let data = dataval.filter((item) => item.select === true || item.select === 1);

    if (data !== undefined && data.length > 0) {
      let primarydata = data.map((a) => a[this.props.primaryKey]);
      if (this.props.SelectedRecords !== undefined) {
        if (this.Ismultiselect === true) {
          this.props.SelectedRecords(data, primarydata);
        } else {
          this.props.SelectedRecords(data[0], primarydata[0]);
        }
      }
    } else {
      if (this.props.SelectedRecords !== undefined) {
        if (this.Ismultiselect === true) {
          this.props.SelectedRecords([], []);
        } else {
          this.props.SelectedRecords({}, "");
        }
      }
    }
  }

  headerSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const data = this.state.orginaldata.map((item) => {
      item.select = checked;
      return item;
    });

    this.formatdata(data);
  };

  onCheckboxheaderchecked = (field, value) => {

    // const data = this.state.orginaldata.map((item) => {
    //   if (item[field] !== null && item[field] !== "NA        ") {
    //     item[field] = value;
    //     if (item.sallow !== undefined && ((item.screate?.trim() === 1 || item.sedit?.trim() === 1 || item.sdelete?.trim() === 1)||(item.screate?.trim() === "1" || item.sedit?.trim() === "1"|| item.sdelete?.trim() === "1"))) {
    //       item.sallow = 1;
    //     } else {
    //       item.sallow = value;
    //     }
    //   }
    //   return item;
    // });

    const data = this.state.orginaldata.map((item) => {
      const fieldValue = item[field];
      if (fieldValue !== null && fieldValue !== "NA        ") {
        const newItem = { ...item, [field]: value };
        const screate = field === "screate" ? value : Number(String(item.screate).trim());
        const sedit = field === "sedit" ? value : Number(String(item.sedit).trim());
        const sdelete = field === "sdelete" ? value : Number(String(item.sdelete).trim());
        if (item.sallow !== undefined && (screate === 1 || sedit === 1 || sdelete === 1)) {
          newItem.sallow = 1;
        } else {
          newItem.sallow = value;
        }
        return newItem;
      }
      return item;
    });


    this.setState({ orginaldata: data });
    let dataset = this.state.dataState;
    dataset.source = data;
    this.setState(
      this.createDataState(
        this.state.skip,
        this.state.pageSize,
        dataset,
        this.state.collapsedIds
      )
    );

    if (this.props.Oncheckboxheaderchecked !== undefined) {
      this.props.Oncheckboxheaderchecked(data);
    }
  };

  onReset = () => {
    // this.setState({
    //     data: process(this.state.orginaldata, this.state.dataState)
    // });
    let dataset = this.state.dataState;
    dataset.source = this.state.orginaldata;
    this.setState(
      this.createDataState(
        this.state.skip,
        this.state.pageSize,
        dataset,
        this.state.collapsedIds
      )
    );
  };

  onColumnsSubmit = (data) => {
    let filterData = data.filter((item) => {
      if (item.filterChecked) {
        return item;
      } else {
        return null;
      }
    });
    this.setState({
      data: process(filterData, this.state.dataState),
    });
  };

  onCheckboxcheckedinvent = (dataobject, field, value) => {
    if (this.props.Oncheckboxchecked !== undefined) {
      this.props.Oncheckboxchecked(
        field,
        value,
        this.props.primaryKey,
        dataobject
      );

      let last = this.lastSelectedIndex;
      if (this.state.orginaldata === undefined) return;

      const data = [...this.state.orginaldata];
      const current = data.findIndex((dataItem) => dataItem === dataobject);

      if (!this.Ismultiselect) {
        this.lastSelectedIndex = last = current;
        data.forEach((item) => (item.select = false));

      } else {

        let select = !dataobject.select;
        for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
          data[i].select = select;
        }
      }

      this.formatdata(data);
    }
  };

  onCheckboxchecked = (dataobject, field, value) => {
    if (this.props.Oncheckboxchecked !== undefined) {
      this.props.Oncheckboxchecked(
        field,
        value,
        this.props.primaryKey,
        dataobject
      );

      let last = this.lastSelectedIndex;
      if (this.state.orginaldata === undefined) return;

      const data = [...this.state.orginaldata];
      const current = data.findIndex((dataItem) => dataItem === dataobject);

      if (!this.Ismultiselect) {
        this.lastSelectedIndex = last = current;
        data.forEach((item) => (item.select = false));
        let select = !dataobject.select;


        const targetTopics = new Set([
          'IDS_TSK_ELNTASKORDER',
          'IDS_TSK_RESEARCHACTIVITY',
          'IDS_TSK_MANAGEEXCEL',
          'IDS_TSK_SHEETEVALUATION',
          'IDS_TSK_DYNAMICPROTOCOL',
          'IDS_TSK_ELNPROTOCOL'
        ]);

        const checkConditionSat = (items) => {
          return items.some(x => targetTopics.has(x?.displaytopic) && (x?.screate?.toString()?.trim() === '1'));
        };

        const conditionSatisfiedSheet = checkConditionSat(data.filter(x => x?.screenname === 'IDS_SCN_SHEETORDERS'));
        const conditionSatisfiedProto = checkConditionSat(data.filter(x => x?.screenname === 'IDS_SCN_PROTOCOLORDERS'));
        const registerIndexSheet = data.findIndex(x => x?.screenname === "IDS_SCN_SHEETORDERS" && x?.displaytopic === "IDS_TSK_REGISTER");
        const registerIndexProto = data.findIndex(x => x?.screenname === "IDS_SCN_PROTOCOLORDERS" && x?.displaytopic === "IDS_TSK_REGISTER");

        for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
          data[i].select = select;

          if (data[i]?.screenname === 'IDS_SCN_SHEETORDERS') {
            if (data[i]?.displaytopic === 'IDS_TSK_REGISTER') {
              data[i].sallow = conditionSatisfiedSheet ? 1 : 0;
            } else if (targetTopics.has(data[i]?.displaytopic) && registerIndexSheet !== -1) {
              data[registerIndexSheet].sallow = conditionSatisfiedSheet ? 1 : 0;
            }
          }

          if (data[i]?.screenname === 'IDS_SCN_PROTOCOLORDERS') {
            if (data[i]?.displaytopic === 'IDS_TSK_REGISTER') {
              data[i].sallow = conditionSatisfiedProto ? 1 : 0;
            } else if (targetTopics.has(data[i]?.displaytopic) && registerIndexProto !== -1) {
              data[registerIndexProto].sallow = conditionSatisfiedProto ? 1 : 0;
            }
          }

          if ((data[i].screate !== undefined && data[i].screate.toString().trim() === "1") ||
            (data[i].sedit !== undefined && data[i].sedit.toString().trim() === "1") ||
            (data[i].sdelete !== undefined && data[i].sdelete.toString().trim() === "1") ||
            (data[i].sallow !== undefined && data[i].sallow.toString().trim() === "1")) {

            let values = document.getElementById(data[i].orderno + "_" + [i])?.value
            if (values !== null) {
              data[i].sallow = 1;
            }
            if (this.props.usergroup === 1) {
              if (field === "screate") {
                data[i].screate = 1;
              } else if (field === "sedit") {
                data[i].sedit = 1;
              }
              else if (field === "sdelete") {
                data[i].sdelete = 1;
              }
              else if (field === "sallow") {
                data[i].sallow = 1;
              }
            }
          } else if ((data[i].screate !== undefined && data[i].screate.toString().trim() === "0") ||
            (data[i].sedit !== undefined && data[i].sedit.toString().trim() === "0") ||
            (data[i].sdelete !== undefined && data[i].sdelete.toString().trim() === "0") ||
            (data[i].sallow !== undefined && data[i].sallow.toString().trim() === "0")) {

            if (this.props.usergroup === 1) {
              if (field === "screate") {
                data[i].screate = 1;
              } else if (field === "sedit") {
                data[i].sedit = 1;
              }
              else if (field === "sdelete") {
                data[i].sdelete = 1;
              }
              else if (field === "sallow") {
                data[i].sallow = 1;
              }
            }
          }
        }
      } else {

        let select = !dataobject.select;
        for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
          data[i].select = select;
        }
      }

      this.formatdata(data);
    }
  };

  onbuttonchecked = (value, field) => {
    if (this.props.OpensheetFn !== undefined) {
      this.props.OpensheetFn(value);
    }
  };

  onDetailClick = (value) => {
    if (this.props.openDetailFn !== undefined) {
      this.props.openDetailFn(value);
    }
  };

  onFileViewClick = (value) => {
    if (this.props.openFileFn !== undefined) {
      this.props.openFileFn(value);
    }
  };

  usersitesCellRenderer = (props, i) => {
    const { dataItem } = props;
    let truncatedsitename = dataItem && dataItem?.sitename && Array.isArray(dataItem.sitename) ? dataItem.sitename.slice(0, dataItem.sitename.length).join(', ') : dataItem.sitename;
    truncatedsitename = truncatedsitename && truncatedsitename.split(' ').filter(Boolean).join('');
    // const allsitename = Array.isArray(dataItem.sitename) ? dataItem.sitename.join(', ') : dataItem.sitename;

    return (
      <td id={props.id + i + this.gridUniqueId}>
        <span title={truncatedsitename}>
          {truncatedsitename}
        </span>
      </td>
    )
  };
  ontransactionclicked = (value, field) => {
    if (this.props.OpenTransaction !== undefined) {
      this.props.OpenTransaction(value);
    }
  };

  MyCustomCell = (props) => (
    <CustomCell
      {...props}
      keyfield={this.props.primaryKey}
      onchange={this.onCheckboxchecked}
      data={this.state.orginaldata}

    />
  );


  MyCustomCellinventory = (props) => (
    <CustomCell
      {...props}
      keyfield={this.props.primaryKey}
      onchange={this.onCheckboxcheckedinvent}
      data={this.state.orginaldata}

    />
  );


  MyCustomCellActiononprotocolorder = (props) => (
    <PendingprotocolorderViewCell
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      // celltype={this.props.Columns[props.columnIndex].celltype}
      Getorderonsharesucess={this.props.Getorderonsharesucess}
      alert={this.props.alert}
      activeKey={this.props.activeKey}
      protocolorderscreen={this.props.protocolorderscreen}
      protocolscreen={this.props.protocolscreen}
    />
  );

  MyCustomCellActiononprotocol = (props) => (
    <Protocolactioncell
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      // celltype={this.props.Columns[props.columnIndex].celltype}
      passbackorder={this.props.Getorderonunshare}
      alert={this.props.alert}
      activeKey={this.props.activeKey}
      protocolorderscreen={this.props.protocolorderscreen}
      protocolscreen={this.props.protocolscreen}
    />
  );

  MyCustomCellActiononparser = (props) => (
    <Parseractioncell
      {...props}
    />
  );

  MyCustomCellActiononsheet = (props) => (
    <Sheetactioncell
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      // celltype={this.props.Columns[props.columnIndex].celltype}
      text={this.props.Columns[props.columnIndex] !== undefined ? this.props.Columns[props.columnIndex].header : ""}
      details={this.props.Columns[props.columnIndex] !== undefined ? isMultitenant === 2 ? this.props.Columns[7].details : this.props.Columns[props.columnIndex].details : ""}
      passbackorder={this.props.Getsharedorderresponse}
      alert={this.props.alert}
      // lang={this.props.t}
      activeKey={this.props.activeKey}
    />
  );

  MyCustomCellActionOnInventory = (props) => (
    <InventoryCell
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      onDetailClick={this.onDetailClick}
      onFileViewClick={this.onFileViewClick}
      text={this.props.Columns[props.columnIndex] !== undefined ? this.props.Columns[props.columnIndex].header : ""}
      details={this.props.Columns[props.columnIndex] !== undefined ? this.props.Columns[props.columnIndex].details : ""}
      alert={this.props.alert}
      activeKey={this.props.activeKey}
    />
  );

  MyCustomCellActionOnEquipment = (props) => (
    <EquipmentCell
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      onDetailClick={this.onDetailClick}
      onFileViewClick={this.onFileViewClick}
      text={this.props.Columns[props.columnIndex] !== undefined ? this.props.Columns[props.columnIndex].header : ""}
      details={this.props.Columns[props.columnIndex] !== undefined ? this.props.Columns[props.columnIndex].details : ""}
      alert={this.props.alert}
      activeKey={this.props.activeKey}
    />
  );

  MyCustomButtonMaterialCell = (props) => (
    <MaterialCell
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      onFileViewClick={this.onFileViewClick}
    />
  );

  MyCustomButtonMaterialActionCell = (props) => (
    <MaterialNameAction
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      onFileViewClick={this.onFileViewClick}
    />
  );

  MyCustomButtonLogbookActionCell = (props) => (
    <LogbookNameAction
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      onFileViewClick={this.onFileViewClick}
    />
  );

  MyCustomCellActiononprotocolsharby = (props) => (
    <Protocolactionsharbycell
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      // Type={this.props?.Type || ""}
      // celltype={this.props.Columns[props.columnIndex].celltype}
      passbackorder={this.props.Getorderonunsharesuccess}
      alert={this.props.alert}
      activeKey={this.props.activekey}
      protocolorderscreen={this.props.protocolorderscreen}
      protocolscreen={this.props.protocolscreen}
    />
  );

  MyCustomCellActiononsheetsharedby = (props) => (
    <Sheetactionsharebycell
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      activeKey={this.props.activeKey}
      // celltype={this.props.Columns[props.columnIndex].celltype}
      Getorderonunshare={this.props.Getorderonunshare}
      alert={this.props.alert}

    />
  );

  MyCustomCellprotocolorderunshareaction = (props) => (
    <ProtocolorderunshareViewCell1
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      // celltype={this.props.Columns[props.columnIndex].celltype}
      Getorderonunshare={this.props.Getorderonunshare}
      alert={this.props.alert}
      activeKey={this.props.activeKey}
      protocolorderscreen={this.props.protocolorderscreen}
      protocolscreen={this.props.protocolscreen}
    // passbackorder={this.props.Columns[i].passbackorder}
    />
  );

  MyCustomCellAction = (props) => (
    <PendingViewCell
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      passbackorder={this.props.passbackorder}
    />
  );

  CompletedcellAction = (props) => (
    <CompletedCelltemp
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
    />
  );

  OrderunsharedbymeCell = (props) => (
    <OrderharedbymeAlart
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
      passbackorder={this.props.passbackorder}
    />
  );
  MyCustomButtonCell = (props) => (
    <MyCustomButtonCell
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.onbuttonchecked}
    />
  );

  MyOrderTransactionCell = (props) => (
    <CustomOrderTransaction
      {...props}
      keyfield={this.props.primaryKey}
      onclick={this.ontransactionclicked}
    />
  );

  formatcolumnwidth(index) {
    let width = "250px";

    if (this?.props?.Columns[index] && this?.props?.Columns[index]?.width !== undefined && this?.props?.Columns[index]?.width !== "") {
      width = this.state.width < 1000 ? this.props.Columns[index].width : undefined;
    }

    if (this.props.Columns[index]?.maxWidth) {
      width = this.props.Columns[index]?.maxWidth
    }

    return width;
  }

  onCheckBoxSelectionall = (e) => {
    const { value, checked } = e.target;

    const { showhidecolumns, gridgroupcode } = this.state;
    const { showhidesgridname } = this.props;

    let updatedColumns = showhidecolumns.map(item => item?.header === value ? { ...item, visible: checked } : item);

    if (showhidesgridname) {
      const usercode = sessionStorage.User;
      const sitecode = sessionStorage.Usersite;

      const passObjDet = {
        gridname: showhidesgridname,
        gridcolumns: JSON.stringify(updatedColumns.filter(item => item.visible).map(item => ({ datatype: item.datatype }))),
        usercode,
        sitecode,
        ...(gridgroupcode && { usergroupedcolcode: gridgroupcode })
      };
      if (this.props.showhidesgridservicecall !== undefined && !this.props.showhidesgridservicecall) {
        // if (updatedColumns?.filter(item => item.visible && item.rowselector !== undefined)?.length > 0 && updatedColumns?.filter(item => item.visible)?.length === 1) {
        //   updatedColumns = updatedColumns.map((item) => {
        //     if (item.rowselector !== undefined&& item.datatype ==="select") {
        //       item.visible = false;
        //       item.rowselector = false;
        //     }
        //     return item;
        //   });
        // } else {
        //   updatedColumns = updatedColumns.map((item) => {
        //     if (item.rowselector !== undefined && item.datatype ==="select") {
        //       item.rowselector = true;
        //     }
        //     return item;
        //   });
        // }
        if (this.props.gridColumnVisibility !== undefined) {
          this.props.gridColumnVisibility(updatedColumns);
        }
        this.setState({ showhidecolumns: updatedColumns, loadGrid: true });
      } else {
        Servicecalls(`${this.ELNurl}/User/setShowHideolumn`, passObjDet, this.onGetShowHideColsuccess.bind(this), this.onSetgroupfailure.bind(this));
      }
    }
  }

  // onCheckBoxSelection = (event) => {
  //   const { value, checked } = event.target;
  //   const { showhidecolumns, gridgroupcode } = this.state;
  //   const { showhidesgridname } = this.props;

  //   const updatedColumns = showhidecolumns.map(item => item?.header === value ? { ...item, visible: checked } : item);

  //   if (showhidesgridname) {
  //     const usercode = sessionStorage.User;
  //     const sitecode = sessionStorage.Usersite;

  //     const passObjDet = {
  //       gridname: showhidesgridname,
  //       gridcolumns: JSON.stringify(updatedColumns.filter(item => item.visible).map(item => ({ datatype: item.datatype }))),
  //       usercode,
  //       sitecode,
  //       ...(gridgroupcode && { usergroupedcolcode: gridgroupcode })
  //     };

  //     Servicecalls(`${this.ELNurl}/User/setShowHideolumn`, passObjDet, this.onGetShowHideColsuccess.bind(this), this.onSetgroupfailure.bind(this));
  //   }
  // };

  onGetShowHideColsuccess = (response) => {
    if (response?.gridcolumns && response?.usergroupedcolcode) {
      const showColms = JSON.parse(response.gridcolumns);

      const stateShowColms = this.state.showhidecolumns.map(item => {
        let isVisible = false;
        showColms.forEach(obj => {
          if (obj.datatype === item.datatype) {
            isVisible = true;
          }
        });
        if (item.isdisabled !== undefined && item.isdisabled) {
          isVisible = true;
        }
        return {
          ...item,
          visible: isVisible,
        };
      });
      if (this.props.gridColumnVisibility !== undefined) {
        this.props.gridColumnVisibility(stateShowColms);
      }
      this.setState({ showhidecolumns: stateShowColms, loadGrid: true });
    } else {
      this.setState({ showhidecolumns: this.props.Columns, loadGrid: true })
    }
  };

  // itemRenderShowHideColumn = (props) => {
  //   return (
  //     (props?.item?.header !== undefined && props?.item?.header !== null && props?.item?.header !== "Action" && props?.item?.celltype !== "materialaction") &&
  //     <em onClick={(e) => e.stopPropagation()}>
  //       <CheckBox
  //         onChange={this.onCheckBoxSelection}
  //         checked={props?.item?.visible}
  //         value={props.item?.header}
  //       />
  //       {" " + props.item?.header}
  //     </em>
  //   );
  // };

  itemRenderShowHideColumnviewall = (props) => {
    let Design = [];
    props.map((items) => {
      let isChecked = items?.visible || (items?.isdisabled === true && items?.visible === false);
      ((items?.header !== undefined && items?.header !== null && items?.header !== this.props.t("Inventory.IDS_ACTION") && items?.header !== this.props.t("Inventory.IDS_ACTION") && items?.celltype !== "materialaction" && items?.datatype !== 'select') || (items?.isallowAction !== undefined && items?.isallowAction)) &&
        Design.push(
          <em onClick={(e) => e.stopPropagation()} key={items.header}>
            <CheckBox
              onChange={this.onCheckBoxSelectionall}
              // checked={items?.visible || items?.isdisabled === true}
              checked={isChecked}
              disabled={items?.isdisabled !== undefined && items?.isdisabled ? true : false}
              value={items.header}
            />
            {" " + items.header}
          </em>)

    })
    return Design
  };

  handleEditColumnHeader(coulmn) {
    this.props?.handleEditColumn(coulmn);
  }

  formatcolumn() {
    let columns = [];
    this.rendercolumn = [];
    this.renderfield = [];

    if (this.state.showhidecolumns !== undefined && this.state.showhidecolumns.length > 0) {
      for (let i = 0; i < this.state.showhidecolumns.length; i++) {
        let columnwidth = this.formatcolumnwidth(i);

        if (this.state.showhidecolumns[i].render !== undefined && this.state.showhidecolumns[i].render === true) {
          this.rendercolumn.push(this.state.showhidecolumns[i].datatype);
        }

        if (this.state.showhidecolumns[i].rowselector) {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              columnType="checkbox"
              locked={this.state.showhidecolumns[i].locked !== undefined && this.state.showhidecolumns[i].locked ? true : false}
              field="select"
              width="50px"
              className="kendo-select-col"
              style={{ "background-color": "red" }}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              headerSelectionValue={
                this.state.orginaldata !== undefined && this.state.orginaldata.length > 0
                  ? this.state.orginaldata.findIndex((dataItem) => dataItem.select === undefined || dataItem.select === false) === -1 : false
              }
            />
          );

          this.Ismultiselect = true;
        } else if (this.state.showhidecolumns[i].celltype === "Checkbox") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: this.MyCustomCell,
                headerCell: (props) => (
                  <CustomHeader
                    {...props}
                    title={this.state.showhidecolumns[i].header}
                    source={this.state.orginaldata}
                    field={this.state.showhidecolumns[i].datatype}
                    onchange={this.onCheckboxheaderchecked}
                  />
                )
              }}
            // columnMenu={(props) => (
            //   <ColumnMenuCheckboxFilter
            //     {...props}
            //     field={this.state.showhidecolumns[i].datatype}
            //     data={this.state.orginaldata}
            //     onReset={this.onReset}
            //     onColumnsSubmit={this.onColumnsSubmit}
            //     primaryKey={this.props.primaryKey}
            //     title={this.state.showhidecolumns[i].header}
            //   />
            // )}
            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "UserRightsCheckbox") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: this.MyCustomCell,
                headerCell: (props) => (
                  <CustomHeaderUserRights
                    {...props}
                    title={this.state.showhidecolumns[i].header}
                    source={this.state.orginaldata}
                    field={this.state.showhidecolumns[i].datatype}
                    onchange={this.onCheckboxheaderchecked}
                  />
                )
              }}
            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "Checkboxinventory") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{ data: this.MyCustomCellinventory }}
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  field={this.state.showhidecolumns[i].datatype}
                  data={this.state.orginaldata}
                  onReset={this.onReset}
                  onColumnsSubmit={this.onColumnsSubmit}
                  primaryKey={this.props.primaryKey}
                  title={this.state.showhidecolumns[i].header}
                />
              )}
            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "Button") {
          columns.push(
            <Column
              locked
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{ data: this.MyCustomButtonCell }}
            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "Detailview") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"70px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <CustomDetailviewCell
                    {...props}
                    keyfield={this.props.primaryKey}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                  />
                )
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "sharesheetorder") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"70px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <Shareorder
                    {...props}
                    keyfield={this.props.primaryKey}
                    isshared={false}
                    props={this.props}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                  />
                )
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "copy") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"150px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: this.MyCustomCellAction
                // , headerCell: (props) => < CustomButtonHeader {...props} /> 
              }}

            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "protocolorderaction") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: this.MyCustomCellActiononprotocolorder
                // , headerCell: (props) => < CustomButtonHeader {...props} /> 
              }}

            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "protocolaction") {
          columns.push(
            <Column
              locked
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"150px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{ data: this.MyCustomCellActiononprotocol }}
            //headerCell={(props) => <CustomButtonHeader {...props} />}
            />
          );
        }

        else if (this.state.showhidecolumns[i].celltype === "parseraction") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: this.MyCustomCellActiononparser
                // , headerCell: (props) => < CustomButtonHeader {...props} /> 
              }}

            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "orderGridView") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={false}
              sortable={(this.state.showhidecolumns[i].sortable === undefined) || (this.state.showhidecolumns[i].sortable !== undefined && this.state.showhidecolumns[i].sortable) ? true : false}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              name
              cells={{
                data: (data) =>
                  (data.dataItem !== undefined && data.dataItem.ordercancell !== undefined && data.dataItem.ordercancell === 1) ?
                    <td id={data.id + i + this.gridUniqueId}>
                      {this.enableTooltip ? this.getLengthValue(data.id, data, i) : <span> {this.getCoulumnText(data.dataItem, data.field)}</span>}
                    </td>
                    :
                    <td id={data.id + i + this.gridUniqueId}>
                      {data?.dataItem?.retirestatus === 1 || data?.dataItem?.transactionstatus === this.props.t("Templates.Protocol.IDS_LBL_RETIRED") || data?.dataItem?.ordercancell === 1 ?
                        <><span> {this.getCoulumnText(data.dataItem, data.field)}</span></> :
                        <NavLink className="column-simple-view"
                          to={{
                            pathname: data?.dataItem?.pathName, state: data.dataItem.template !== undefined ? {
                              batchid: data.dataItem.id, batchcode: data.dataItem.code,
                              perviouspath: "/dashboard"
                            } : { ...data.dataItem, perviouspath: "/dashboard" }
                          }}
                          onClick={() => { if (this.props.Onstoredatetoredux !== undefined) { this.props.Onstoredatetoredux() } }}
                        >
                          {this.enableTooltip ? this.getLengthValue(data.id, data, i) : <span> {this.getCoulumnText(data.dataItem, data.field)}</span>}
                        </NavLink>
                      }
                    </td>
              }}
            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "customStatusColumn") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={false}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              name
              cells={{
                data: (data) =>
                  <td id={data.id + i + this.gridUniqueId}>
                    <span className={`grid-custom-status ${data.dataItem[this.state.showhidecolumns[i].datatype]}`}>

                      {this.enableTooltip ?
                        this.getLengthValue(data.id, data, i)
                        :
                        <span>
                          {this.getCoulumnText(data.dataItem, data.field)}
                        </span>
                      }
                    </span>
                  </td>
              }}
            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "customStatusInventory") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={false}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              name
              cells={{
                data: (data) =>
                  <td id={data.id + i + this.gridUniqueId}>
                    <span className={`grid-custom-status-inventory ${data.dataItem[this.state.showhidecolumns[i].datatype]}`}>
                      {this.enableTooltip ?
                        this.getLengthValue(data.id, data, i)
                        :
                        <span>
                          {this.getCoulumnText(data.dataItem, data.field)}
                        </span>
                      }
                    </span>
                  </td>
              }}
            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "dateColumn" || this.state.showhidecolumns[i].celltype === "Datecolumn_Completed" || this.state.showhidecolumns[i].celltype === "dateColumn_duedate") {
          const propertyNames = this.state.showhidecolumns[i].datatype.split('.');
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={false}
              sortable={(this.state.showhidecolumns[i].sortable === undefined) || (this.state.showhidecolumns[i].sortable !== undefined && this.state.showhidecolumns[i].sortable) ? true : false}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              name
              cells={{
                data: (data) =>
                  <>
                    <td>
                      <div className="calender-list horizontal d-flex" data-toggle="tooltip" title={data.dataItem[this.state.showhidecolumns[i].datatype]}>
                        {propertyNames.length === 1 ? data.dataItem[propertyNames[0]] : propertyNames.reduce((obj, prop) => obj && obj[prop], data.dataItem)}
                        {/* <span className="eln-stamp" data-toggle="tooltip" title={data.dataItem.month + " " + data.dataItem.day + " " + data.dataItem.year + " " + data.dataItem.time + " " + data.dataItem.Time_Zone}>{data.dataItem.month}</span>
                        <span className="eln-date" data-toggle="tooltip" title={data.dataItem.month + " " + data.dataItem.day + "/" + data.dataItem.year + " " + data.dataItem.time + " " + data.dataItem.Time_Zone}>{data.dataItem.day}</span>
                        <span className="eln-stamp" data-toggle="tooltip" title={data.dataItem.month + " " + data.dataItem.day + " " + data.dataItem.year + " " + data.dataItem.time + " " + data.dataItem.Time_Zone}>{data.dataItem.year}</span>
                        <span className="eln-stamp" data-toggle="tooltip" title={data.dataItem.month + " " + data.dataItem.day + " " + data.dataItem.year + " " + data.dataItem.time + " " + data.dataItem.Time_Zone}>{data.dataItem.time}</span>
                        <span className="eln-stamp" data-toggle="tooltip" title={data.dataItem.month + " " + data.dataItem.day + " " + data.dataItem.year + " " + data.dataItem.time + " " + data.dataItem.Time_Zone}>{data.dataItem.Time_Zone}</span> */}
                      </div>
                    </td>
                  </>
              }}
            />
          );
          // }
          // else if (this.state.showhidecolumns[i].celltype === "Datecolumn_Completed") {
          //   columns.push(
          //     <Column
          //       key={this.state.showhidecolumns[i].datatype}
          //       field={this.state.showhidecolumns[i].datatype}
          //       width={columnwidth}
          //       title={this.state.showhidecolumns[i].header}
          //       editable={false}
          //       sortable={(this.state.showhidecolumns[i].sortable === undefined) || (this.state.showhidecolumns[i].sortable !== undefined && this.state.showhidecolumns[i].sortable) ? true : false}
          //       resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
          //       name
          //       cells={{
          //         data: (data) =>
          //           <>
          //             <td>
          //               <div className="calender-list horizontal d-flex" data-toggle="tooltip" title={data.dataItem[this.state.showhidecolumns[i].datatype]}>
          //                 {data.dataItem[this.state.showhidecolumns[i].datatype]}
          //                 {/* <span className="eln-stamp" data-toggle="tooltip" title={data.dataItem.Month_Complete + " " + data.dataItem.Day_Complete + " " + data.dataItem.Year_Complete + " " + data.dataItem.Time_Complete}>{data.dataItem.Month_Complete}</span>
          //                 <span className="eln-date" data-toggle="tooltip" title={data.dataItem.Month_Complete + " " + data.dataItem.Day_Complete + "/" + data.dataItem.Year_Complete + " " + data.dataItem.Time_Complete}>{data.dataItem.Day_Complete}</span>
          //                 <span className="eln-stamp" data-toggle="tooltip" title={data.dataItem.Month_Complete + " " + data.dataItem.Day_Complete + " " + data.dataItem.Year_Complete + " " + data.dataItem.Time_Complete}>{data.dataItem.Year_Complete}</span>
          //                 <span className="eln-stamp" data-toggle="tooltip" title={data.dataItem.Month_Complete + " " + data.dataItem.Day_Complete + " " + data.dataItem.Year_Complete + " " + data.dataItem.Time_Complete}>{data.dataItem.Time_Complete}</span> */}
          //               </div>
          //             </td>
          //           </>
          //       }}
          //     />
          //   );
          // }
          // else if (this.state.showhidecolumns[i].celltype === "dateColumn_duedate") {
          //   columns.push(
          //     <Column
          //       key={this.state.showhidecolumns[i].datatype}
          //       field={this.state.showhidecolumns[i].datatype}
          //       width={columnwidth}
          //       title={this.state.showhidecolumns[i].header}
          //       editable={false}
          //       sortable={(this.state.showhidecolumns[i].sortable === undefined) || (this.state.showhidecolumns[i].sortable !== undefined && this.state.showhidecolumns[i].sortable) ? true : false}
          //       resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
          //       name
          //       cells={{
          //         data: (data) =>
          //           <>
          //             <td>
          //               <div className="calender-list horizontal d-flex" data-toggle="tooltip" title={data.dataItem[this.state.showhidecolumns[i].datatype]}>
          //                 {data.dataItem[this.state.showhidecolumns[i].datatype]}
          //                 {/* <span className="eln-stamp" data-toggle="tooltip" title={data.dataItem.month_duedate + " " + data.dataItem.day_duedate + " " + data.dataItem.year_duedate + " " + data.dataItem.time_duedate}>{data.dataItem.month_duedate}</span>
          //                 <span className="eln-date" data-toggle="tooltip" title={data.dataItem.month_duedate + " " + data.dataItem.day_duedate + "/" + data.dataItem.year_duedate + " " + data.dataItem.time_duedate}>{data.dataItem.day_duedate}</span>
          //                 <span className="eln-stamp" data-toggle="tooltip" title={data.dataItem.month_duedate + " " + data.dataItem.day_duedate + " " + data.dataItem.year_duedate + " " + data.dataItem.time_duedate}>{data.dataItem.year_duedate}</span>
          //                 <span className="eln-stamp" data-toggle="tooltip" title={data.dataItem.month_duedate + " " + data.dataItem.day_duedate + " " + data.dataItem.year_duedate + " " + data.dataItem.time_duedate}>{data.dataItem.time_duedate}</span> */}
          //                 {/* <span className="eln-stamp" data-toggle="tooltip" title={data.dataItem.month_duedate + " " + data.dataItem.day_duedate + " " + data.dataItem.year_duedate + " " + data.dataItem.time_duedate}>{data.dataItem.Time_Zone}</span> */}
          //               </div>
          //             </td>
          //           </>
          //       }}
          //     />
          //   );
        } else if (this.state.showhidecolumns[i].celltype === "Hyperlink" || (this.state.showhidecolumns[i].celltype === "customfield" && this.state.showhidecolumns[i].isHyperLink)) {

          if (this.state.showhidecolumns[i]?.visible === true) {
            columns.push(
              <Column
                key={this.state.showhidecolumns[i].datatype}
                field={this.state.showhidecolumns[i].datatype}
                width={columnwidth}
                title={this.state.showhidecolumns[i].header}
                editable={false}
                sortable={(this.state.showhidecolumns[i].sortable === undefined) || (this.state.showhidecolumns[i].sortable !== undefined && this.state.showhidecolumns[i].sortable) ? true : false}
                resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
                name
                cells={{
                  data: (props) => {
                    const value = this.getCoulumnText(props.dataItem, props.field) ?? "";
                    const isHyperLink = this.state.showhidecolumns[i].isHyperLink;
                    const href = !isHyperLink
                      ? value
                      : value.startsWith("http://") || value.startsWith("https://")
                        ? value
                        : `https://${value}`;

                    return (
                      <td>
                        <a style={{ color: "#1970eb" }} href={href} target="_blank" rel="noopener noreferrer">
                          {value}
                        </a>
                      </td>
                    );
                  }
                }
                }

                {...this.columnProps(
                  this.state.showhidecolumns[i].datatype,
                  this.state.orginaldata,
                  this.props.primaryKey,
                  this.state.showhidecolumns[i].header
                )}

              />
            );
          }

        } else if (this.state.showhidecolumns[i].celltype === "sheetaction") {
          columns.push(
            <Column
              locked
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"150px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{ data: this.MyCustomCellActiononsheet }}
            //headerCell={(props) => <CustomButtonHeader {...props} />}
            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "inventoryaction") {
          columns.push(
            <Column
              locked
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"140px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{ data: this.MyCustomCellActionOnInventory }}
            //headerCell={(props) => <CustomButtonHeader {...props} />}
            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "equipmentaction") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"140px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: this.MyCustomCellActionOnEquipment
                // , headerCell: (props) => < CustomButtonHeader {...props} /> 
              }}

            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "MaterialButton") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"140px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: this.MyCustomButtonMaterialCell
                // , headerCell: (props) => < CustomButtonHeader {...props} /> 
              }}

            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "materialaction") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"200px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: this.MyCustomButtonMaterialActionCell
                // , headerCell: (props) => <>
                //   <div className="custom-th-wrap"> <CustomButtonHeaderforusergroup {...props} />
                //     <GridColumnMenuWrapper {...props.columnMenuWrapperProps} /></div>
                // </>
              }}
              {...this.columnProps(
                this.state.showhidecolumns[i].datatype,
                this.state.orginaldata,
                this.props.primaryKey,
                this.state.showhidecolumns[i].header
              )}
            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "logbookaction" && this.state.showhidecolumns[i].visible) {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"200px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={i == 0 ? { data: this.MyCustomButtonLogbookActionCell } : undefined}
            //headerCell={(props) => <CustomButtonHeader {...props} />}
            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "protocolsharedbyaction") {
          columns.push(
            <Column
              locked
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{ data: this.MyCustomCellActiononprotocolsharby }}
            //headerCell={(props) => <CustomButtonHeader {...props} />}
            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "sheetsharedbyaction") {
          columns.push(
            <Column
              locked
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{ data: this.MyCustomCellActiononsheetsharedby }}
            //headerCell={(props) => <CustomButtonHeader {...props} />}
            />
          );
        } else if (
          this.state.showhidecolumns[i].celltype === "completebuttontemplate"
        ) {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"150px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: this.CompletedcellAction
                // , headerCell: (props) => < CustomButtonHeader {...props} /> 
              }}

            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "orderunsharedbyme") {

          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              // onclick={this.sharedbyclick}
              cells={{
                data: (props) => <OrderharedbymeAlart
                  {...props}
                  keyfield={this.props.primaryKey}
                  onclick={this.onbuttonchecked}
                  passbackorder={this.state.showhidecolumns[i].passbackorder}
                />
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}
            // passbackorder={this.props.passbackorder}

            />
          );
        }
        else if (
          this.state.showhidecolumns[i].celltype === "protocolorderunshareaction"
        ) {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}

              cells={{
                data: (props) => <ProtocolorderunshareViewCell1
                  {...props}
                  keyfield={this.props.primaryKey}
                  alert={this.props.alert}
                  activeKey={this.props.activeKey}
                  protocolorderscreen={this.props.protocolorderscreen}
                  protocolscreen={this.props.protocolscreen}
                  onclick={this.onbuttonchecked}
                  passbackorder={this.state.showhidecolumns[i].passbackorder}
                />
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "unshareprotocoltemplate") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"70px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <UnshareforprotocolTemplate
                    {...props}
                    keyfield={this.props.primaryKey}
                    isshared={false}
                    props={this.props}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                    passbackorder={this.props.Getorderonunsharesuccess}
                  />
                )
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "sharesheettemplate") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"70px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <ShareforsheetTemplate
                    {...props}
                    keyfield={this.props.primaryKey}
                    isshared={false}
                    props={this.props}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                    passbackorder={this.props.Getsharedorderresponse}
                  />
                )
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        } else if (
          this.state.showhidecolumns[i].celltype === "unshareprotocoltemplate"
        ) {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"70px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <UnshareforprotocolTemplate
                    {...props}
                    keyfield={this.props.primaryKey}
                    isshared={false}
                    props={this.props}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                    passbackorder={this.props.Getorderonunsharesuccess}
                  />
                )
                // , headerCell: (props) => < CustomButtonHeader {...props} />

              }}

            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "sharesheettemplate") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"70px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <ShareforsheetTemplate
                    {...props}
                    keyfield={this.props.primaryKey}
                    isshared={false}
                    props={this.props}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                    passbackorder={this.props.Getsharedorderresponse}
                  />
                )
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "projectTeamsView") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype !== undefined ? this.state.showhidecolumns[i].datatype : "projectteamcol_" + i}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <CustomUsergroupviewCells
                    {...props}
                    keyfield={this.props.primaryKey}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                  />
                )
                // , headerCell: (props) => (
                //   <CustomButtonHeaderforusergroup {...props} />
                // )
              }}

            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "usergroupviews") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <CustomUsergroupviewCells
                    {...props}
                    keyfield={this.props.primaryKey}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                  />
                )
                // , headerCell: (props) => (
                //   <CustomButtonHeaderforusergroup {...props} />
                // )
              }}

            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "usermastermultisite") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              locked={this.state.showhidecolumns[i].locked !== undefined && this.state.showhidecolumns[i].locked ? true : false}
              field={this.state.showhidecolumns[i].datatype}
              width={this.state.showhidecolumns[i].locked === undefined ? columnwidth : this.state.showhidecolumns[i].width}
              className="breakWord60 text-wrap"
              title={this.state.showhidecolumns[i].header}
              cells={{
                data: (props) => (
                  this.usersitesCellRenderer(props, i)
                )
                // , headerCell: (props) => {
                //   return (
                //     <div className="custom-th-wrap">
                //       <span className="th-tooltip" id={props.field + i + this.gridUniqueId}>
                //         {this.enableTooltip ?

                //           this.getLengthValue(props.field, props, i, 'header')

                //           :
                //           <span>
                //             {props.title ? props.title : props.field}
                //           </span>
                //         }
                //       </span>
                //       {this.state.showhidecolumns[i].doFilter !== undefined && this.state.showhidecolumns[i].doFilter ? true :
                //         <GridColumnMenuWrapper
                //           {...props.columnMenuWrapperProps}
                //           {...this.columnProps(
                //             this.state.showhidecolumns[i].datatype,
                //             this.state.orginaldata,
                //             this.props.primaryKey,
                //             this.state.showhidecolumns[i].header
                //           )}
                //         />
                //       }
                //     </div>
                //   )
                // }

              }}

              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              {...this.columnProps(
                this.state.showhidecolumns[i].datatype,
                this.state.orginaldata,
                this.props.primaryKey,
                this.state.showhidecolumns[i].header
              )}
            />);

        }
        else if (this.state.showhidecolumns[i].celltype === "ordertransactions") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={"70px"}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <Customcompletecell
                    {...props}
                    keyfield={this.props.primaryKey}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                  />
                )
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "inventryhistory") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <Custominventrycells
                    {...props}
                    keyfield={this.props.primaryKey}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                  />
                )
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "formatversiondetails" || this.state.showhidecolumns[i].celltype === "CommonTransactionHistoryDesing" || this.state.showhidecolumns[i].celltype === "ProtocolTransactionHistory") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => {
                  const column = this.state.showhidecolumns[i];
                  return column.celltype === "formatversiondetails" ? (
                    <Formatprotocolversioncell
                      {...props}
                      keyfield={this.props.primaryKey}
                      text={column.header}
                      details={column.details}
                      index={i}
                    />
                  ) : (
                    <FormateTransactionHistoryDetails
                      {...props}
                      keyfield={this.props.primaryKey}
                      text={column.header}
                      details={column.details}
                      index={i}
                    />
                  );
                },
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "formatresultdetails") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <FormatResultUsedDetailscell
                    {...props}
                    keyfield={this.props.primaryKey}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                    index={i}
                  />
                )
              }
              }
            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "formatresultequipmentdetails") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <FormatResultUsedEquipment
                    {...props}
                    keyfield={this.props.primaryKey}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                    index={i}
                  />
                )
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        } else if (this.state.showhidecolumns[i].celltype === "formattransactiondetails") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <Formatprotocoltransactioncell
                    {...props}
                    keyfield={this.props.primaryKey}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                    index={i}
                  />
                )
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "formatprotocolordertransactiondetails") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <Formatprotocolordertransactioncell
                    {...props}
                    keyfield={this.props.primaryKey}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                    index={i}
                  />
                )
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        }
        else if (this.state.showhidecolumns[i].celltype === "formatprotocolorderversiondetails") {
          columns.push(
            <Column
              key={this.state.showhidecolumns[i].datatype}
              field={this.state.showhidecolumns[i].datatype}
              width={columnwidth}
              title={this.state.showhidecolumns[i].header}
              editable={true}
              resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
              cells={{
                data: (props) => (
                  <Formatprotocolversiondetailscell
                    {...props}
                    keyfield={this.props.primaryKey}
                    text={this.state.showhidecolumns[i].header}
                    details={this.state.showhidecolumns[i].details}
                    index={i}
                  />
                )
                // , headerCell: (props) => < CustomButtonHeader {...props} />
              }}

            />
          );
        }
        else if (this.state.showhidecolumns[i].visible) {
          if (this.state.showhidecolumns[i].format !== undefined) {
            columns.push(
              <Column
                key={this.state.showhidecolumns[i].datatype}
                field={this.state.showhidecolumns[i].datatype}
                locked={this.state.showhidecolumns[i].locked !== undefined && this.state.showhidecolumns[i].locked ? true : false}
                width={this.state.showhidecolumns[i].locked === undefined ? columnwidth : this.state.showhidecolumns[i].width}
                className="breakWord120"
                title={this.state.showhidecolumns[i].header}
                filter="date"
                format={this.state.showhidecolumns[i].format}
                resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
                columnMenu={(props) => (
                  <ColumnMenuCheckboxFilter
                    {...props}
                    field={this.state.showhidecolumns[i].datatype}
                    data={this.state.orginaldata}
                    onReset={this.onReset}
                    onColumnsSubmit={this.onColumnsSubmit}
                    primaryKey={this.props.primaryKey}
                    title={this.state.showhidecolumns[i].header}
                  />
                )}
              />
            );
          } else if (this.state.showhidecolumns[i].celltype === "noWrapColumn") {
            columns.push(
              <Column
                key={this.state.showhidecolumns[i].datatype}
                locked={this.state.showhidecolumns[i].locked !== undefined && this.state.showhidecolumns[i].locked ? true : false}
                field={this.state.showhidecolumns[i].datatype}
                width={this.state.showhidecolumns[i].locked === undefined ? columnwidth : this.state.showhidecolumns[i].width}
                className="breakWord60 text-wrap"
                title={this.state.showhidecolumns[i].header}
                resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
                cells={{
                  data: (props) => (
                    <td id={props.id + i + this.gridUniqueId}>

                      {this.enableTooltip ?
                        this.getLengthValue(props.id, props, i)
                        :
                        <span>
                          {this.getCoulumnText(props.dataItem, props.field)}
                        </span>
                      }
                    </td>
                  )
                  // , headerCell: (props) => {
                  //   return (
                  //     <div className="custom-th-wrap">
                  //       <span className="th-tooltip " id={props.field + i + this.gridUniqueId}>
                  //         {this.enableTooltip ?

                  //           this.getLengthValue(props.field, props, i, 'header')

                  //           :
                  //           <span>
                  //             {props.title ? props.title : props.field}
                  //           </span>
                  //         }
                  //       </span>
                  //       {this.state.showhidecolumns[i].doFilter !== undefined && this.state.showhidecolumns[i].doFilter ? true :
                  //         <GridColumnMenuWrapper
                  //           {...props.columnMenuWrapperProps}
                  //           {...this.columnProps(
                  //             this.state.showhidecolumns[i].datatype,
                  //             this.state.orginaldata,
                  //             this.props.primaryKey,
                  //             this.state.showhidecolumns[i].header
                  //           )}
                  //         />
                  //       }
                  //     </div>
                  //   )
                  // }

                }}
              />);

          } else {
            columns.push(
              <Column
                key={this.state.showhidecolumns[i].datatype}
                locked={this.state.showhidecolumns[i].locked !== undefined && this.state.showhidecolumns[i].locked ? true : false}
                field={this.state.showhidecolumns[i].datatype}
                width={this.state.showhidecolumns[i].locked === undefined ? columnwidth : this.state.showhidecolumns[i].width}
                className="breakWord60 text-wrap"
                title={this.state.showhidecolumns[i].header}
                // cells={{
                //   headerCell: (props) => {
                //     return (
                //       <div className="custom-th-wrap">
                //         <span className="th-tooltip" id={props.field + i + this.gridUniqueId}>
                //           {this.enableTooltip ?

                //             this.getLengthValue(props.field, props, i, 'header')

                //             :
                //             <span className={`${this.state.showhidecolumns[i].celltype === "customfield" ? "spanwidth" : ""}`}>
                //               {props.title ? props.title : props.field}
                //             </span>
                //           }
                //         </span>
                //         {/* {this.state.showhidecolumns[i].celltype === "customfield" &&
                //         <button
                //           id="edit-header-btn"
                //           className="float-right"
                //           onClick={() => this.handleEditColumnHeader(this.state.showhidecolumns[i])}
                //         >
                //           <i className="fas fa-pencil-alt" title="Edit"></i>
                //         </button>
                //       } */}
                //         {this.state.showhidecolumns[i].doFilter !== undefined && this.state.showhidecolumns[i].doFilter ? true :
                //           <GridColumnMenuWrapper
                //             {...props.columnMenuWrapperProps}
                //             {...this.columnProps(
                //               this.state.showhidecolumns[i].datatype,
                //               this.state.orginaldata,
                //               this.props.primaryKey,
                //               this.state.showhidecolumns[i].header
                //             )}
                //           />
                //         }
                //       </div>
                //     )
                //   }
                // }}
                resizable={(this.state.showhidecolumns[i].resizable === undefined) || (this.state.showhidecolumns[i].resizable !== undefined && this.state.showhidecolumns[i].resizable) ? true : false}
                {...this.columnProps(
                  this.state.showhidecolumns[i].datatype,
                  this.state.orginaldata,
                  this.props.primaryKey,
                  this.state.showhidecolumns[i].header
                )}
              />);

          }
        }
      }
    }

    if (columns.length === 0) {
      return <Column
        field="placeholder"
        title="No Data Available"
        cells={{
          data: () => (
            <td style={{ textAlign: 'center' }}>No columns to display</td>
          )
        }}
      // width="100%"
      />
    }
    return columns;
  }
  getCoulumnText(data, key) {
    let value = "";
    if (key.includes(".")) {
      let keys = key.split(".")
      keys.forEach((obj) => {
        value = value ? value[obj] : data[obj]
      })
    } else {
      value = data[key]
    }
    if (typeof value === 'boolean' || value instanceof Date) {
      value = String(value)
    }
    return value

  }
  getLengthValue = (elementId, props, i, type) => {
    const id = elementId + i + this.gridUniqueId
    const data = document.getElementById(id)
    let value = "";
    let content = ""
    if (type !== 'header') {
      if (props?.field.includes(".")) {
        let keys = props.field.split(".")
        keys.forEach((obj) => {
          value = value ? value[obj] : props.dataItem[obj]
        })
      } else {
        value = props.dataItem[props.field]
      }
      if (typeof value === 'boolean') {
        value = String(value)
      }
    } else {
      value = props.title ? props.title : props.field
    }
    if (data && data.scrollWidth && data.clientHeight && data.clientWidth < data.scrollWidth) {
      content = (
        <span title={value}>
          {value}
        </span>
      )
    } else {
      content = (
        <span>
          {value}
        </span>
      )
    }
    return content
  }

  columnProps = (field, orginaldata, primaryKey, header) => {
    if (!this.props.hideColumnFilter) {
      return {
        columnMenu: (props) => (
          <ColumnMenu
            {...props}
            field={field}
            data={this.state.orginaldata}
            onReset={this.onReset}
            onColumnsSubmit={this.onColumnsSubmit}
            primaryKey={primaryKey}
          />
        ),
        // headerClassName: this.isColumnActive(field, this.state.dataState) ? "active" : "",
      };
    }
  };

  // isColumnActive = (field, dataState) => {
  //   return (
  //     GridColumnMenuFilter.active(field, dataState.filter) ||
  //     GridColumnMenuSort.active(field, dataState.sort)
  //   );
  // };

  cellRender = (cell, props) => {
    if (this.rendercolumn.includes(props.field)) {
      let st = this.state.data;
      let values = st?.data?.reduce(function (r, a) {
        r[a[props.field]] = r[a[props.field]] || [];
        r[a[props.field]].push(a);
        return r;
      }, Object.create(null));

      let object = values !== undefined && values[props.dataItem[props.field]];
      if (!this.renderfield.includes(props.dataItem[props.field])) {
        this.renderfield.push(props.dataItem[props.field]);
        let span = object !== undefined ? object.length : 1;
        return (
          <td rowSpan={span}>
            {props.dataItem[props.field] !== undefined &&
              props.dataItem[props.field] !== null
              ? props.dataItem[props.field].toString()
              : props.dataItem[props.field]}
          </td>
        );
      } else {
        return null;
      }
    }
    return cell;
  };

  pageChange = (event) => {
    let dataset = this.state.dataState;
    // if (this.props.pagechangeeevent === undefined) {
    localStorage.setItem((this.props.Gridname !== undefined && ((this.props.Gridname === "orders") || (this.props.Gridname === "template"))) ? "ElnitemperpageDashboard" : "Elnitemperpage", event.page.take);
    // }
    dataset.source = this.state.orginaldata;

    this.setState(
      this.createDataState(
        event.page.skip,
        event.page.take,
        dataset,
        this.state.collapsedIds
      ), () => {
        console.log(this.state.dataState);
        if (this.props.pagechangeeevent !== undefined && this.props.Gridname !== undefined) {
          // parseInt(event.nativeEvent.target.textContent) - 1
          this.props.pagechangeeevent((event.page.skip / this.props.pageperrecors), event.page.take, this.props.Gridname)
        }
      }
    );

  };

  onimporteddats = (onsavefinaldata, emptycolumnname) => {
    if (emptycolumnname.length > 0) {
      this.isDuplicateobj.emptycolumnname = emptycolumnname[0];
      this.isDuplicateobj.totalcolumnempty = emptycolumnname.length;
    } else if (emptycolumnname.length === 0) {
      this.isDuplicateobj.emptycolumnname = "";
      this.isDuplicateobj.totalcolumnempty = emptycolumnname.length;
    }
    this.onsavefinaldata = onsavefinaldata;
  }

  // onImport = (e) => {
  //   if (this.props.onImportDataGet !== undefined) {
  //     this.props.onImportDataGet();
  //   }
  //   e.preventDefault();
  //   this.setState({ IsOpen: true });
  //   this.props.onsavegriddata([], true);
  // }

  closeModel = (e) => {
    e.preventDefault();
    this.setState({ IsOpen: false });
    this.props.onsavegriddata([], true);
  }

  onsavegriddata = () => {
    this.onsavefinaldata = this.onsavefinaldata.filter((x) => {
      return Object.keys(x).length > 0;
    })
    if (this.onsavefinaldata.length > 0 && this.isDuplicateobj.emptycolumnname === "") {
      let mandaterycolumns = this.state.showhidecolumns
      mandaterycolumns = mandaterycolumns.filter(items => items.ismandatory !== undefined && items.ismandatory);

      let isAcceptable = undefined, dataName = undefined;

      if (mandaterycolumns.length > 0) {
        mandaterycolumns.some((items) => {
          let valueArr = this.onsavefinaldata.map(function (item) {
            return item[items.datatype]
          });

          if (items.acceptabletype !== undefined) {
            if (items.acceptabletype === 'Number') {
              valueArr.map((x) => { if (x !== undefined && !Number.isInteger(Number(x))) { isAcceptable = false } });
              if (isAcceptable === false) {
                dataName = items.header;
              }
            } else if (items.acceptabletype === 'Predefined_0') {
              valueArr.map((x) => { if (x !== undefined && x.toLowerCase() !== 'yes' && x.toLowerCase() !== 'no') { isAcceptable = false } });
              if (!isAcceptable === false) {
                dataName = items.header;
              }
            } else if (items.acceptabletype === 'Predefined_1') {
              valueArr.map((x) => { if (x !== undefined && x.toLowerCase() !== 'no expiry' && x.toLowerCase() !== 'expiry date' && x.toLowerCase() !== 'expiry policy') { isAcceptable = false } });
              if (!isAcceptable === false) {
                dataName = items.header;
              }
            }
          }
          // if (isAcceptable === undefined) {
          if (valueArr.length === this.onsavefinaldata.length) {
            this.isDuplicateobj.isDuplicate = valueArr.some((item, idx) => {
              if (items.ignoremandatory !== undefined && (item === undefined || item === null || item === "")) {
                this.isDuplicateobj.index = -1;
                return true;
              } else {
                this.isDuplicateobj.index = idx;
              }

              return valueArr.indexOf(item) != idx;
            });
            // console.log(this.isDuplicateobj);
            if (this.isDuplicateobj.isDuplicate && this.isDuplicateobj.index !== -1 && items.ignoredublicate === undefined) {
              this.props.alert.error(this.props.t("Dashboard.Sheetorders.IDS_MSG_DUBLICATERECORD", {
                Username: items.header
              }));
              return true;
            } else {
              this.isDuplicateobj.isDuplicate = false
            }
            return false;
          }
          this.props.alert.error(this.props.t("Dashboard.Sheetorders.IDS_MSG_DUBLICATERECORD", { Username: items.header }));
          return true;
          // }
        })
      }
      if (isAcceptable === undefined) {
        if (!this.isDuplicateobj.isDuplicate) {
          this.props.onsavegriddata(this.onsavefinaldata, null);
        } else {
          this.setState({ ischangegriddata: true })
        }
      } else {
        this.props.alert.error(`${dataName} the acceptable type of data has been changed`)
      }
    } else {

      if (this.onsavefinaldata.length === 0) {
        this.props.alert.error("Select file to import");
      } else {
        this.props.alert.error(this.props.t("Dashboard.Sheetorders.IDS_MSG_EMPTYCOLUMN", { column: this.isDuplicateobj.emptycolumnname }));
      }
    }
  }

  render() {
    let lang = localStorage.getItem("ElnLang");
    let localizeprovider = "en-EN";
    if (lang !== null) {
      localizeprovider = lang + "-" + lang.toUpperCase();
    }
    const selectedState = {};
    this.state.data?.data?.forEach(item => {
      if (item.select === true || item.select === 1) {
        selectedState[this.idGetter(item)] = true;
      }
    });
    // const filteredColumns = showhidecolumns.filter(
    //   (item) =>
    //     typeof item === 'object' &&
    //     item !== undefined &&
    //     item !== null &&
    //     item !== false &&
    //     Object.keys(item).length > 0 &&
    //     (item?.show === undefined || item?.show) &&
    //     item?.header !== undefined
    // );
    return (
      <div className="at-list-table">

        {this.state.IsOpen &&
          <Modal isOpen={this.state.IsOpen} className={"modal-lg"}>
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {this.props.t("Common.IDS_LBL_IMPORTDATA")}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.closeModel.bind(this)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <ModalBody>
              <ImportData ischangegriddata={this.state.ischangegriddata} isDuplicateobj={this.isDuplicateobj} Columns={this.state.showhidecolumns} t={this.props.t} onimporteddats={this.onimporteddats.bind(this)} alert={this.props.alert}></ImportData>
            </ModalBody>
            <div id="UserMasterADD-modal-footer" className="modal-footer">
              <button
                type="button"
                id="idSaveSheetAs"
                className="btn btn-user btn-primary-blue"
                onClick={this.onsavegriddata.bind(this)}
              >
                {this.props.t("Setup.Userrights.IDS_LBL_SAVE")}
              </button>
              <button
                type="button"
                className="btn modalbluebtn button"
                onClick={this.closeModel.bind(this)}
              >
                {this.props.t("Header.IDS_LBL_CLOSE", { param: "", })}
              </button>
            </div>
          </Modal>
        }

        {this.state?.loadGrid &&
          <LocalizationProvider language={localizeprovider}>
            {/* <IntlProvider locale={lang} > */}
            {/* {this.state.data &&
          this.state.data &&
          this.state.data.data.length > 0 ? ( */}
            <Tooltip openDelay={100} position="top">
              <ExcelExport data={this.state.dataState?.source} ref={this.export} fileName={this.props.screenName}>
                {/* <div style={{ marginBottom: '10px' }}>
                {this.renderColumnToggles()}
              </div>       */}

                {
                  <Grid
                    key={
                      (this.state.showhidecolumns
                        ?.filter(c => c.Isshow)            /** dashboard grid data doesn't disappears on unchecking checkbox */
                        ?.map(c => c.datatype)
                        ?.join(',')) || 'defaultGridKey'
                    }
                    data={process(this.state.dataState.source, {
                      skip: this.state.dataState.skip,
                      take: this.state.dataState.take,
                      group: this.state.dataState.group,
                      sort: this.state.dataState.sort,
                      filter: this.state.dataState.filter,
                    })}
                    group={this.state.dataState.group}
                    // data={this.state.data}
                    // {...this.state.dataState}
                    // style={{
                    //   height: this.props.height !== undefined ? this.props.height : "auto",
                    // }}
                    style={{ height: "calc(100vh - 220px)" }}
                    selectedField="select"
                    selectable={{
                      enabled: true, mode: "multiple",
                      checkboxOnly: true,
                    }}
                    select={selectedState} //this.state.data?.data?.filter((items) => items.select === true || items.select === 1)?.map((item) => item[this.props.primaryKey])}
                    dataItemKey={this.props.primaryKey}
                    onSelectionChange={this.selectionChange}
                    onHeaderSelectionChange={this.headerSelectionChange}
                    onRowClick={this.rowClick}
                    onDataStateChange={this.dataStateChange}
                    onGroupChange={this.onGroupChange}
                    onExpandChange={this.onExpandChange}
                    expandField="expanded"
                    sortable={true}
                    onPageChange={this.pageChange}
                    groupable={this.props.name !== undefined ? true : false}
                    total={this.state.total}
                    skip={this.state.skip}
                    pageable={this.state.pageable}
                    pageSize={this.state.pageSize}
                    cellRender={this.cellRender}
                    resizable
                  // fixedScroll={true}
                  >
                    {this.formatcolumn()}

                    {/* <GridToolbar>
{this.props.screenName !== undefined ? <>
<button
                    title=""
                    className="btn btn btn-primary-blue mg-l-1"
                    onClick={this.onImport}
                    disabled={this.props.Usermaster === true ? false : this.props.Usermaster === undefined ? false : true}
                  >
                    {this.props.t("Common.IDS_LBL_IMPORT")}
                  </button>


                  <span title={this.props.t("Common.IDS_LBL_EXPORT")}>
                    <DropdownButton
                      drop="down"
                      alignRight
                      // variant="primary"
                      // title="Download"
                      // name="Download"
                      className='download-btn'
                      variant="outline-light"
                    // ref={this.methodRef}
                    // hidden={!this.props.Login.visibility}
                    >
                      <Dropdown.Item
                        key={"samplesplitKey"}
                        value={"SampleSplit"}
                        onSelect={() =>
                          this.excelExport()
                          // this.switchButton("sampleSplit", "SampleSplit")
                        }
                      >
                        {this.props.t("Parser.Instrument.IDS_LBL_EXPORTEXCEL")}
                      </Dropdown.Item>
                      <Dropdown.Item
                        key={"parsersetupkey"}
                        value={"ParserSetup"}
                        onSelect={() =>
                          this.exportPDF()
                          // this.switchButton("sampleSplit", "SampleSplit")
                        }
                      >
                        {this.props.t("Parser.Instrument.IDS_LBL_EXPORTPDF")}
                      </Dropdown.Item>
                      <Dropdown.Item
                        key={"evaluateparserkey"}
                        value={"EvaluateParser"}
                        onSelect={() =>
                          this.onxportcsv()
                        }
                      >
                        {this.props.t("Parser.Instrument.IDS_LBL_EXPORTCSV")}
                      </Dropdown.Item>

                    </DropdownButton>
                  </span>
</>: false}

                </GridToolbar>  */}

                    {this.props.screenName === undefined && this.props.showhidesgridname ?
                      <GridToolbar className="filter-bar">
                        {/* <SplitButton
                      imageUrl={"./images/eyeicon.png"}
                      textField={"Show/hide"}
                      itemRender={this.itemRenderShowHideColumn}
                      className="showHide_dropdown"
                      items={this?.state?.showhidecolumns?.filter(item => typeof item === "object" && item !== undefined && item !== null && item !== false && Object.keys(item).length > 0 && (item?.show === undefined || item?.show) && (item?.celltype !== "materialaction") && (item?.datatype !== "select") && (item?.header !== undefined))}
                    // text = {'Show/hide'}
                    /> */}

                        <Button className="btn_white_bg mr-4" title={this.props.t("Setup.Usermaster.IDS_LBL_SHOWHIDECOLLUMN")} onClick={this.togglePopup}>
                          <img src="./images/eyeicon.png" />
                        </Button>
                        {this.state.isPopupVisible && (
                          <div id="viewallfilter" className="modal result-modal d-block" data-keyboard="false" role="dialog" aria-labelledby="myModalLabel" >
                            <div className="modal-dialog fixed-dailogbox modal-lg" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">{this.props.t("Setup.Usermaster.IDS_LBL_SHOWHIDECOLLUMN")}</h5>
                                  <button
                                    type="button"
                                    className="close"
                                    onClick={this.togglePopup}
                                  >
                                    &times;
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="viewall-list">{this.itemRenderShowHideColumnviewall(this.state.showhidecolumns)}</div>
                                </div>
                                <div className="modal-footer">
                                  <button className="textBtn btn_white_bg" onClick={this.togglePopup}>
                                    {this.props.t("Setup.Usermaster.IDS_LBL_CLOSE")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </GridToolbar> : false}

                    {this.props.screenName !== undefined ? (
                      <GridToolbar>
                        <>
                          {/* <button
                            title="Import"
                            className="btn btn_white_bg mg-l-1 import-button"
                            onClick={this.onImport}
                            disabled={this.props.Usermaster === true ? false : this.props.Usermaster === undefined ? false : true}
                          > */}
                          {/* <i className="fa fa-upload fa-3" title="Import"></i> */}
                          {/* {this.props.t("Common.IDS_LBL_IMPORT")} */}
                          {/* </button> */}

                          <span title="Export">
                            {/* title={this.props.t("Common.IDS_LBL_EXPORT")} */}
                            <DropdownButton
                              drop="down"
                              alignRight
                              className="download-btn pop-top-down"
                              variant="outline-light"
                            >
                              <Dropdown.Item
                                key={"samplesplitKey"}
                                value={"SampleSplit"}
                                onSelect={() => this.excelExport()}
                              >
                                {this.props.t("Parser.Instrument.IDS_LBL_EXPORTEXCEL")}
                              </Dropdown.Item>
                              {/* <Dropdown.Item
                                key={"parsersetupkey"}
                                value={"ParserSetup"}
                                onSelect={() => this.exportPDF()}
                              >
                                {this.props.t("Parser.Instrument.IDS_LBL_EXPORTPDF")}
                              </Dropdown.Item> */}
                              <Dropdown.Item
                                key={"evaluateparserkey"}
                                value={"EvaluateParser"}
                                onSelect={() => this.onxportcsv()}
                              >
                                {this.props.t("Parser.Instrument.IDS_LBL_EXPORTCSV")}
                              </Dropdown.Item>
                            </DropdownButton>
                          </span>
                        </>
                        {this.props.showhidesgridname &&
                          <>
                            <span className="d-inline-block" style={{ marginRight: "20px" }}>
                              <Button className="btn_white_bg" title={this.props.t("Setup.Usermaster.IDS_LBL_SHOWHIDECOLLUMN")} onClick={this.togglePopup}>
                                <img alt="eye" title={this.props.t("Setup.Usermaster.IDS_LBL_SHOWHIDECOLLUMN")} src="./images/eyeicon.png" style={{ width: "12px" }} />
                              </Button></span>
                            {this.state.isPopupVisible && (
                              <div id="viewallfilter" className="modal result-modal d-block" data-keyboard="false" role="dialog" aria-labelledby="myModalLabel" >
                                <div className="modal-dialog fixed-dailogbox modal-lg" role="document">
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h5 className="modal-title">{this.props.t("Setup.Usermaster.IDS_LBL_SHOWHIDECOLLUMN")}</h5>
                                      <button
                                        type="button"
                                        className="close"
                                        onClick={this.togglePopup}
                                      >
                                        &times;
                                      </button>
                                    </div>
                                    <div className="modal-body">
                                      <div className="viewall-list">{this.itemRenderShowHideColumnviewall(this.state.showhidecolumns)}</div>
                                    </div>
                                    <div className="modal-footer">
                                      <button className="textBtn btn_white_bg" onClick={this.togglePopup}>
                                        {this.props.t("Setup.Usermaster.IDS_LBL_CLOSE")}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                          // <SplitButton
                          //   imageUrl={"./images/eyeicon.png"}
                          //   textField={"Show/hide"}
                          //   itemRender={this.itemRenderShowHideColumn}
                          //   className="showHide_dropdown"
                          //   items={this?.state?.showhidecolumns?.filter(item => typeof item === "object" && item !== undefined && item !== null && item !== false && Object.keys(item).length > 0 && (item?.show === undefined || item?.show) && (item?.celltype !== "materialaction") && (item?.datatype !== "select") && (item?.header !== undefined))}
                          // // text = {'Show/hide'}
                          // />
                        }
                      </GridToolbar>) : false}

                    {/* <Column
                            field="selected"
                            width="50px"
                            headerSelectionValue={
                                this.state.data.findIndex(dataItem => dataItem.selected === false) === -1
                            } />
                        <Column field="ProductName" title="Product Name" width="300px" />
                        <Column field="UnitsInStock" title="Units In Stock" />
                        <Column field="UnitsOnOrder" title="Units On Order" />
                        <Column field="ReorderLevel" title="Reorder Level" /> */}
                  </Grid>
                }


              </ExcelExport>
            </Tooltip>
            {/* <GridPDFExport allPages={true} ref={(pdfExport) => (gridPDFExport = pdfExport)}>
              <Grid
                data={this.state.data}
                {...this.state.dataState}
              >
                {this.formatcolumn()}
              </Grid>
            </GridPDFExport> */}
          </LocalizationProvider>
        }
      </div>
    );
  }
}
export default withAlert()(withTranslation(KendoGridView));